export default __webpack_public_path__ + "static/media/bannerAddPackage.a8d07421.jpg";